import React from "react";

export default function Stages() {
  return (
    <section id="stages" className="stages section section-dark">
      <div className="container">
        <div className="section-header">
          {/* Обновленный заголовок: фокус на результате, а не на процессе */}
          <div className="section-badge">Этапы разработки</div>
          
          {/* НОВАЯ ФРАЗА: Старт проекта — от 1500 ₽/час */}
          {/* <p className="price-tag">Старт проекта — от <strong>1 500 ₽/час</strong></p> */}

          <h2>От идеи до стабильной работы.</h2>
          <p className="description">
            Прозрачный процесс, который превращает вашу идею в работающий цифровой продукт.
          </p>
        </div>

        {/* Блок 1: Анализ и планирование */}
        <div className="service-block">
          <div>
            <div className="text-content">
              <div className="section-badge">1. Анализ и планирование</div>
              <h3>Анализ и бесплатная консультация</h3>
              <p className="description">
                Составление технического задания {'ТЗ'} и дорожной карты.
              </p>
              <ul className="benefits-list">
                <li><span className="checkmark">✓</span> Сэкономите бюджет, отсекая ненужные функции.</li>
                <li><span className="checkmark">✓</span> Получите честную оценку сложности и сроков.</li>
                <li><span className="checkmark">✓</span> Поймете точную стоимость разработки.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Блок 2: Визуализация и прототипирование */}
        <div className="service-block">
          <div>
            <div className="text-content">
              <div className="section-badge">2. Визуализация и прототипирование</div>
              <h3>Интерактивный прототип</h3>
              <p className="description">
                Создаю интерактивный прототип для тестирования логики.
              </p>
              <ul className="benefits-list">
                <li><span className="checkmark">✓</span> Рабочий HTML/CSS/JS-макет для тестирования.</li>
                <li><span className="checkmark">✓</span> Вы сможете «пощупать» интерфейс и проверить логику в деле.</li>
                <li><span className="checkmark">✓</span> Гарантирует, что финальный продукт будет соответствовать ожиданиям.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Блок 3: Разработка (MVP) */}
        <div className="service-block">
          <div>
            <div className="text-content">
              <div className="section-badge">3. Разработка {'(MVP)'}</div>
              <h3>Быстрый запуск и проверка идеи</h3>
              <p className="description">
                Создаю минимально жизнеспособный продукт {'(MVP)'} для быстрого выхода на рынок.
              </p>
              <ul className="benefits-list">
                <li><span className="checkmark">✓</span> Проверку бизнес-идеи с минимальными рисками.</li>
                <li><span className="checkmark">✓</span> Стабильный продукт, готовый к первым пользователям.</li>
                <li><span className="checkmark">✓</span> Надежный фундамент для будущего масштабирования.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Блок 4: Максимальная видимость (Next.js) */}
        <div className="service-block">
          <div>
            <div className="text-content">
              <div className="section-badge">4. Максимальная видимость {'(Next.js)'}</div>
              <h3>Разработка на Next.js</h3>
              <p className="description">
                Для проектов, нацеленных на рост органического трафика из поиска.
              </p>
              <ul className="benefits-list">
                <li><span className="checkmark">✓</span> Идеальная индексация поисковиками {'(Google, Яндекс)'}.</li>
                <li><span className="checkmark">✓</span> Молниеносная скорость загрузки страниц.</li>
                <li><span className="checkmark">✓</span> Готовая инфраструктура для SEO-продвижения.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Блок 5: Техническая поддержка и развитие (ОБЪЕДИНЕННЫЙ) */}
        <div className="service-block">
          <div>
            <div className="text-content">
              <div className="section-badge">5. Техническая поддержка и развитие</div>
              <h3> Техническая поддержка и запуск</h3>
              <p className="description">
                Стабильная работа, исправление ошибок и помощь с запуском {'(домен, хостинг)'}.
              </p>
              <ul className="benefits-list">
                <li><span className="checkmark">✓</span> Спокойствие и уверенность в стабильной работе проекта.</li>
                <li><span className="checkmark">✓</span> Помощь с техническими вопросами запуска, чтобы вы могли сосредоточиться на бизнесе.</li>
                <li><span className="checkmark">✓</span> Разработка новых функций по мере роста вашего бизнеса.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* НОВЫЙ БЛОК: Призыв к действию с новой формулировкой */}
        <div className="service-block">
          <div>
            <div className="text-content">
              <p className="description">
                {/* Новая, сильная формулировка вместо "цены обсуждаются" */}
                Для оценки стоимости мы начинаем с <span className="title-accent">бесплатной консультации и составления технического задания</span>.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
